import styled from 'astroturf/react';

import Button from 'src/components/Button';
import Svg from 'src/components/Svg';
import TextField from 'src/components/TextField';
import { Popup } from 'src/components/Popup';

const container = styled('div')`
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  background-color: var(--black);
  z-index: 9999;
  display: flex;
`;

const imageBox = styled('div')`
  display: grid;
  height: 100%;
  width: 100%;
`;

const image = styled('img')`
  max-width: 85vw;
  max-height: 95vh;
  height: 85vh;
  width: auto;
  position: absolute;
  top: 1%;
  bottom: 0;
  left: 0;
  right: 0;
  margin: 0 auto;
  object-fit: contain;
`;

const DataRowContainer = styled('div')`
  position: absolute;
  height: 15vh;
  min-width: 100%;
  display: flex;
  bottom: 0;
  left: auto;
  right: auto;
  margin: auto;
  background-color: var(--white);
  padding: 1rem;
  align-items: center;
  justify-content: center;
  font-weight: bolder;
`;

const dataRow = styled('div')`
  height: 100%;
  width: 45%;
`;

const icon = styled(Svg)`
  width: 15px;
  height: 15px;
  cursor: pointer;
  top: 10px;
  right: 26px;

  path {
    fill: var(--ph-gray-400);
  }

  &.close {
    position: absolute;
  }

  &.edit {
    position: relative;
    left: 1em;
    top: 0.2em;
  }
`;

const buttonContainer = styled('div')`
  height: max-content;
  width: max-content;
  position: absolute;
  top: 50%;
  margin: 0;
  z-index: 9999;

  &.prev {
    left: 0;
  }

  &.next {
    right: 0;
  }

  & button:active {
    background-color: var(--ph-orange-200);
    color: var(--ph-gray-100);
  }
`;

const descriptionContainer = styled('div')
  .attrs(props => ({
    ...props,
    style:{ overflow: props.expand ? 'auto' : 'hidden' }
  }))`
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  max-width: 75%;
  height: 2.5em;
`;

const TagsRowLabel = styled('p')`
  font-weight: bold;
  font-size: medium;
  margin: 0;
  padding-bottom: 0.5em;

  &.linked-questions {
    padding-bottom: 0;
  }
`;

const saveDescriptionButton = styled(Button)`
  height: 30px;
  font-size: small;
  margin-left: 10px;
`;

const descriptionTextField = styled(TextField)`
  & > div:first-child {
    margin-left: auto;
    min-width: fit-content;
    margin-right: 5px;
  }
`;

const ActionBtnContainer = styled('div')`
  cursor: pointer;
  font-size: small;
  font-weight: bold;
  display: flex;
  align-items: center;
  padding-bottom: 0.5em;

  &.remove {
    position: absolute;
    right: 1rem;
    top: 1rem;
  }
`;

const ActionButton = styled(Svg)`
  border-radius: 50%;
  height: 20px;
  width: 20px;

  circle {
    fill: var(--ph-light-blue-500);
  }

  path {
    fill: var(--white);
  }

  &.path-blue{
    height: 15px;
    path {
      fill: var(--ph-light-blue-500);
    }
  }

  &.reload {
    polyline {
      stroke: var(--ph-light-blue-500) !important;
    }
    path {
      stroke: var(--ph-light-blue-500) !important;;
    }
  }
`;

const ManageQuestionsBtn = styled(Svg)`
  border-radius: 50%;
  height: 20px;
  width: 20px;
  padding: 0.3rem;
  vertical-align: center;
  background-color: var(--ph-light-blue-500);
  line-height: 1rem;

  path {
    fill: var(--white);
  }
`;

const DataCellItem = styled('div')`
  display: flex;
  align-items: center;
  width: 100%;
`;

const PhotoDeleteConfirmPopup = styled(Popup)`
  padding: 20px;
  left: 20%;
  right: 30%; 

  p {
    color: var(--ph-gray-500);
  }

  [id='icon-cross'] {
    top: 15px;
  }
`;

const PhotoDeletePopupActionBtnContainer = styled('div')`
  display: flex;
  justify-content: space-between;

  [class*='deleteConfirmBtn'] {
    background: var(--cyan-green) !important;
  }
`;


export default {
  ActionButton,
  ActionBtnContainer,
  ButtonContainer: buttonContainer,
  Container: container,
  DataRow: dataRow,
  DataCellItem,
  DataRowContainer,
  DescriptionContainer: descriptionContainer,
  DescriptionTextField: descriptionTextField,
  Icon: icon,
  Image: image,
  ImageBox: imageBox,
  ManageQuestionsBtn,
  SaveDescriptionButton: saveDescriptionButton,
  TagsRowLabel,
  PhotoDeleteConfirmPopup,
  PhotoDeletePopupActionBtnContainer
};
